import { render, staticRenderFns } from "./visual-diff.vue?vue&type=template&id=65710b30&"
import script from "./visual-diff.vue?vue&type=script&lang=js&"
export * from "./visual-diff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports